import { useState } from 'react'

interface UsePaginationProps {
  initialPerpage?: number
}

export function usePagination({
  initialPerpage = 10,
}: UsePaginationProps = {}) {
  const [page, setPage] = useState(1)
  const [perpage, setPerpage] = useState(initialPerpage)
  const [total, setTotal] = useState(0)

  function pageChange(newPage: number) {
    setPage(newPage)
  }

  function perpageChange(newPerpage: number) {
    setPerpage(newPerpage)
    setPage(1)
  }

  function handleTotalChange(newTotal: number) {
    setTotal(newTotal)
  }

  return {
    page,
    perpage,
    total,
    pageChange,
    perpageChange,
    handleTotalChange,
  }
}
